import {ReferralTypeEnum, type ShareActivityLinkAnalytics} from '../../../../shared/entity_datas/EntityDatas.ts'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes.ts'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'
import {setElementInnerHTML, createParagraphIn, createDivIn, createImgIn, createHeaderIn} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {ReferralProgram, type ReferralReward} from '../../../../shared/ReferralProgram.ts'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {clientI18n} from '../../../shared/scripts/ClientI18n.ts'

export class ViewPopupRewardsProgram extends ViewPopup {
    constructor(analyticsPopupTriggered: ShareActivityLinkAnalytics, analyticsSuccessfullyShared: ShareActivityLinkAnalytics) {
        const action = () => {
            ViewPopupRewardsProgram.showDiscordShareActivityLinkPopup(analyticsPopupTriggered, analyticsSuccessfullyShared)
            navigateToPage('/store#referrals')
        }

        super({key: 'strings:homePage.popups.rewardsProgram.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            action,
            () => undefined, true,
            {
                showXButton: false,
                showCheckButton: true,
                showXonHeader: true,
            })

        this.body.style.flexDirection = 'column'

        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})
        createParagraphIn(this.body, {key: 'strings:homePage.popups.rewardsProgram.body'}, 'popup-membership-body')

        const imageWrapper = createDivIn(this.body, 'popup-subscription-in-room-items-wrapper', '')
        const referralProgram = ReferralProgram.referralRewardLevels
        referralProgram.forEach((referralReward: ReferralReward) => {
            const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
            createImgIn(imageCard, referralReward.image)
            createHeaderIn(imageCard, referralReward.name, '')
            createParagraphIn(imageCard, {key: 'strings:homePage.popups.rewardsProgram.description', options: {count: referralReward.referralCount}}, '')
            imageWrapper.appendChild(imageCard)
        })

        this.changeCheckButtonText({key: 'strings:homePage.popups.rewardsProgram.button'})
        this.show()
    }

    static showDiscordShareActivityLinkPopup(analyticsPopupTriggered: ShareActivityLinkAnalytics, analyticsSuccessfullyShared: ShareActivityLinkAnalytics) {
        DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareActivityLink, {
            message: clientI18n.t('strings:homePage.popups.discordShareActivity.text'),
            referralTypeId: ReferralTypeEnum.DiscordShareActivityReturnToHomeAfterGameEndPopup.toString(),
            analyticsPopupTriggered: analyticsPopupTriggered,
            analyticsPopupSuccess: analyticsSuccessfullyShared,
        })
    }
}
